import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Row, Col, Form } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useGetCountriesNew } from 'all-in-one-shared-api';
// import TextArea from 'antd/es/input/TextArea';
// import { Spinner } from 'components';
import React, {
  useEffect,
  // useState
} from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import redright from 'assets/images/redright.svg';
// import { useNavigate } from 'react-router-dom';
import { corrAddressListItem } from '../ChangeContactInformation';
import { isLocaleEnglish } from 'utils/languageUtils';

export const ContactCard = (props: {
  corrAddressList: corrAddressListItem[];
  downloadServiceFormEn?: string;
  downloadServiceFormTc?: string;
}) => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);

  const form = useFormInstance();
  const { token } = useKeycloakReady();
  // const [residentialAddressCountry, setresidentialAddress5] = useState('');
  // const navigate = useNavigate();
  const { shouldFetch: shouldFecthGetCountry, data: countriesDataList } = useGetCountriesNew(
    'useGetCountriesNew',
    token || '',
    '',
    '2',
  );
  const myCountryList = countriesDataList?.residentialCountries.map((item) => {
    return {
      label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
      value: item.t3645Alpha3Country,
      sanctionLevel: item.sanctionLevel,
    };
  });
  // const corresCountryList = countriesDataList?.correspondenceCountries.map((item) => {
  //   return {
  //     label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
  //     value: item.t3645Alpha3Country,
  //     sanctionLevel: item.sanctionLevel,
  //   };
  // });
  const downloadPdf = () => {
    if (isEnglish) {
      if (props.downloadServiceFormEn) {
        const link = document.createElement('a');
        const url = props.downloadServiceFormEn;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    } else {
      if (props.downloadServiceFormTc) {
        const link = document.createElement('a');
        const url = props.downloadServiceFormTc;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    }
  };

  useEffect(() => {
    shouldFecthGetCountry(true);
  }, [shouldFecthGetCountry]);
  useEffect(() => {
    const a = myCountryList?.find((item) => item.value === form.getFieldValue('residentialAddress5'))?.label;
    if (a) {
      // setresidentialAddress5(a);
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [
    // setresidentialAddress5,
    myCountryList,
    form,
  ]);

  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 8 }]}>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          label={
            <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
              {t('life.MakeRequest.contact.Name')}
            </span>
          }
          name="name"
        >
          <div
            style={{
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
            }}
          >
            {form.getFieldValue('name')}
          </div>
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          label={
            <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
              {t('life.MakeRequest.contact.Email')}
            </span>
          }
          name="email"
        >
          <div
            style={{
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div> {form.getFieldValue('email') == '' ? '—' : form.getFieldValue('email')}</div>
            {form.getFieldValue('emailFlag') === 'Y' && (
              <div
                style={{
                  background: '#E9573D',
                  borderRadius: '20px',
                  padding: '4px 8px',
                  fontSize: '15px',
                  fontFamily: 'Roboto700',
                  color: '#FFF',
                  display: 'inline-block',
                  height: '24px',
                  lineHeight: '17px',
                  marginTop: '16px',
                }}
              >
                {t('life.MakeRequest.contact.UnderReview')}
              </div>
            )}
          </div>
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          label={
            <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
              {t('life.MakeRequest.contact.MobileNumber')}
            </span>
          }
          name="mobileNumber"
        >
          <div
            style={{
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <span style={{ marginRight: '10px' }}>
                {form.getFieldValue('mobilePhoneCountryCode') ? form.getFieldValue('mobilePhoneCountryCode') : ''}
              </span>
              {form.getFieldValue('mobileNumber') == '' ? '—' : form.getFieldValue('mobileNumber')}
            </div>
            {form.getFieldValue('mobileNumberFlag') === 'Y' && (
              <div
                style={{
                  background: '#E9573D',
                  borderRadius: '20px',
                  padding: '4px 8px',
                  fontSize: '15px',
                  fontFamily: 'Roboto700',
                  color: '#FFF',
                }}
              >
                {t('life.MakeRequest.contact.UnderReview')}
              </div>
            )}
          </div>
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          label={
            <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
              {t('life.MakeRequest.contact.HomeNumber')}
            </span>
          }
          name="homeNumber"
        >
          <div
            style={{
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <span style={{ marginRight: '10px' }}>
                {form.getFieldValue('homePhoneCountryCode') ? form.getFieldValue('homePhoneCountryCode') : ''}
              </span>
              {form.getFieldValue('homeNumber') == '' ? '—' : form.getFieldValue('homeNumber')}
            </div>

            {form.getFieldValue('homeNumberFlag') === 'Y' && (
              <div
                style={{
                  background: '#E9573D',
                  borderRadius: '20px',
                  padding: '4px 8px',
                  fontSize: '15px',
                  fontFamily: 'Roboto700',
                  color: '#FFF',
                }}
              >
                {t('life.MakeRequest.contact.UnderReview')}
              </div>
            )}
          </div>
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          label={
            <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
              {t('life.MakeRequest.contact.OfficeNumber')}
            </span>
          }
          name="officeNumber"
        >
          <div
            style={{
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <span style={{ marginRight: '10px' }}>
                {form.getFieldValue('officePhoneCountryCode') ? form.getFieldValue('officePhoneCountryCode') : ''}
              </span>
              {form.getFieldValue('officeNumber') == '' ? '—' : form.getFieldValue('officeNumber')}
            </div>
            {form.getFieldValue('officeNumberFlag') === 'Y' && (
              <div
                style={{
                  background: '#E9573D',
                  borderRadius: '20px',
                  padding: '4px 8px',
                  fontSize: '15px',
                  fontFamily: 'Roboto700',
                  color: '#FFF',
                }}
              >
                {t('life.MakeRequest.contact.UnderReview')}
              </div>
            )}
          </div>
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <Form.Item
          label={
            <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
              {t('life.MakeRequest.contact.ResidentialAddress')}
            </span>
          }
          name="residentialAddress1"
        >
          <div
            style={{
              border: 'none',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              display: 'flex',
              justifyContent: 'space-between',
              color: '#20252b',
            }}
          >
            {form.getFieldValue('residentialAddress1')}
            {form.getFieldValue('residentialAddressFlag') === 'Y' && (
              <div
                style={{
                  background: '#E9573D',
                  borderRadius: '20px',
                  padding: '4px 8px',
                  fontSize: '15px',
                  fontFamily: 'Roboto700',
                  color: '#FFF',
                }}
              >
                {t('life.MakeRequest.contact.UnderReview')}
              </div>
            )}
          </div>
          <div
            style={{
              border: 'none',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              color: '#20252b',
            }}
          >
            {form.getFieldValue('residentialAddress2')}
          </div>
          <div
            style={{
              border: 'none',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              color: '#20252b',
            }}
          >
            {form.getFieldValue('residentialAddress3')}
          </div>
          <div
            style={{
              // border: 'none',
              // // color: "white",
              // backgroundColor: 'transparent',
              // fontSize: '20px',
              // fontFamily: 'Roboto400',
              // color: '#20252b',
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              paddingBottom: '4px',
              color: '#20252b',
            }}
          >
            {form.getFieldValue('residentialAddress4')}
          </div>
          {/* <div
            style={{
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              paddingBottom: '4px',
              color: '#20252b',
            }}
          >
            {residentialAddressCountry}
          </div> */}
        </Form.Item>
        {/* {(props.policyNumber !== '' || form.getFieldValue('correspondenceAddressFlag') === 'Y') && ( */}
      </Col>
      <Col xs={24} md={24}>
        <div className="header2">
          <div
            style={{
              fontSize: '22px',
              fontFamily: 'Roboto400',
              color: '#6f7072',
            }}
          >
            {t('life.MakeRequest.contact.PolicyInformation')}
          </div>
        </div>
        <Form.Item
          label={
            <span
              style={{
                color: '#6f7072',
                fontWeight: 'normal',
                fontSize: '17px',
                fontFamily: 'Roboto500',
                marginTop: '10px',
              }}
            >
              {t('life.MakeRequest.contact.CorrespondenceAddress')}
            </span>
          }
          name="corrAddress1"
        >
          {props.corrAddressList?.map((item, index) => (
            <div style={{ display: 'grid' }} key={index + item.productName + 'Add'}>
              <div key={index + 'corrAddressList'} style={{ borderBottom: '1px solid #CCCCCC', paddingBottom: '10px' }}>
                <div
                  style={{
                    color: '#20252B',
                    fontWeight: 'normal',
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    marginTop: '8px',
                  }}
                >
                  {i18n.language == 'en' ? item.productName : item.productNameTc}
                </div>
                <div
                  style={{
                    color: '#20252B',
                    fontWeight: 'normal',
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                  }}
                >
                  {t('life.enquiry.policyNo')}
                  {item.policyNumber}
                </div>
              </div>
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '10px' }}
              >
                <div
                  key={index + item.corrAddress1 + 'add1'}
                  style={{
                    border: 'none',
                    // color: "white",
                    backgroundColor: 'transparent',
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: '#20252B',
                  }}
                >
                  {item.corrAddress1}
                </div>
                {item.correspondenceAddressFlag == 'Y' && (
                  <div
                    style={{
                      background: '#E9573D',
                      borderRadius: '20px',
                      padding: '4px 8px',
                      fontSize: '15px',
                      fontFamily: 'Roboto700',
                      color: '#FFF',
                    }}
                  >
                    {t('life.MakeRequest.contact.UnderReview')}
                  </div>
                )}
              </div>
              <div
                key={index + item.corrAddress2 + 'add2'}
                style={{
                  border: 'none',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontFamily: 'Roboto400',
                  fontSize: '17px',
                  color: '#20252B',
                }}
              >
                {item.corrAddress2}
              </div>
              <div
                key={index + item.corrAddress3 + 'add3'}
                style={{
                  border: 'none',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontFamily: 'Roboto400',
                  fontSize: '17px',
                  color: '#20252B',
                }}
              >
                {item.corrAddress3}
              </div>
              <div
                key={index + item.corrAddress4 + 'add4'}
                style={{
                  // border: 'none',
                  // // color: "white",
                  // backgroundColor: 'transparent',
                  // fontFamily: 'Roboto400',
                  // fontSize: '17px',
                  // color: '#20252B',
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  paddingBottom: '4px',
                  fontSize: '17px',
                  color: '#20252B',
                }}
              >
                {item.corrAddress4}
              </div>
              {/* <div
                key={index + item.corrAddress5 + 'add5'}
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  paddingBottom: '4px',
                  fontSize: '17px',
                  color: '#20252B',
                }}
              >
                {corresCountryList?.find((i) => i.value === item.corrAddressCountry)?.label}
              </div> */}
            </div>
          ))}
        </Form.Item>
      </Col>
      <Col xs={24} md={24}>
        <div
          style={{
            border: 'none',
            // color: "white",
            backgroundColor: 'transparent',
            fontSize: '17px',
            fontFamily: 'Roboto400',
            color: '#6F7072',
          }}
        >
          {t('life.MakeRequest.contact.FooterText')}
        </div>
      </Col>
      <Col xs={24} md={24}>
        <div
          style={{
            border: 'none',
            // color: "white",
            backgroundColor: 'transparent',
            fontSize: '17px',
            fontFamily: 'Roboto500',
            color: '#C21B17',
            textAlign: 'center',
          }}
        >
          <span onClick={downloadPdf} style={{ cursor: 'pointer' }}>
            {t('life.MakeRequest.contact.FooterButton')}
            <img src={redright} style={{ margin: '0  2px 0 10px', width: '8px', height: '14px' }} />
          </span>
        </div>
      </Col>
    </Row>
  );
};
